import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'CMO',
  version: 1,
  label: 'Chande Momentum Oscillator',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 170,
  inputs: [period('timeperiod', 14)],
  outputs: [line('cmo', 'CMO', COLOR.purple)],
  levels: [{ value: 50 }, { value: -50 }],
  talib: { functions: ['CMO'], expr: 'CMO(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod,
}
export default def
